import React, { useEffect, useState } from 'react'
import { useAppData } from '../../../../../context/AppDataContext'
import InvoiceItemForm from './InvoiceItemForm';
import invoiceItemServices from '../invoiceItemServices';
import ConfirmDelete from '../../../../../components/ConfirmDelete';
import { useAlert } from '../../../../../context/AlertContext';
import { NumberToWords } from './NumberToWords';



function InvoiceItemList({invoiceDetails,productList,isPrinting}) {
    const {getMasterLabel} = useAppData();
    const {AppAlert} = useAlert();

    const [subTotal,setSubTotal] = useState(0);
    const [grandTotal,setGrandTotal] = useState(0);
    const [gstTotal,setGstTotal] = useState(0);


    const [itemList,setItemList] = useState([]);

    const getItemList = () =>{
        invoiceItemServices.getByInvoiceId(invoiceDetails.id).then(res=>{
            setItemList(res.data);
        }).catch(error=>{
        }).finally(()=>{
        })
    }

    useEffect(()=>{
        getItemList();
    },[invoiceDetails])

    



    const calculateTotal = () =>{
        if(itemList){
            let _subTotal = Number(0);
            let _gstTotal = Number(0);
            let _grandTotal = Number(0);
            for(const _item of itemList) {
                _subTotal   += Number(_item.amount);
                _gstTotal   += Number(_item.gstAmount);
                _grandTotal += Number(_item.totalAmount);
            }
        
            setSubTotal(_subTotal);
            setGstTotal(_gstTotal);
            setGrandTotal(_grandTotal);
        }
    }
    
    useEffect(()=>{
        calculateTotal();
    },[itemList])

    const deleteItem = (id) =>{
        invoiceItemServices.remove(id).then(res=>{
            AppAlert("Removed Successfully");
            getItemList();
        }).catch(error=>{
            AppAlert(error.msg,"error")
        })
    }

    return (
    itemList &&
    <table className='table table-sm table-striped table-bordered mb-0' style={{fontSize:12}}>
        <thead>
            <tr className=''>
                <th>#</th>
                <th>Description</th>
                <th>HSN</th>
                <th>Qty</th>
                <th>UOM</th>
                <th>Price</th>
                <th>GST%</th>
                <th>Amount</th>
                {/*
                    <th>GST</th>
                    <th>Total</th>
                */}
            </tr>
        </thead>
        <tbody>
            {itemList.map((item,i)=>
                <tr key={i} className="hover-container">
                    <td>{i+1}</td>
                    <td >
                        {item.title}
                        <ConfirmDelete id={item.id} confirm={deleteItem} >Are you sure you want to remove {item.title}</ConfirmDelete>
                    </td>
                    <td>{item.hsn}</td>
                    <td>{item.qty}</td>
                    <td>{ getMasterLabel("product-uom",item.uom)}</td>
                    <td>{item.price}</td>
                    <td>{item.gstRate}</td>
                    <td>{item.amount}</td>
                    {/*
                        <td>{item.gstAmount}</td>
                        <td>{item.totalAmount}</td>
                    */}
                </tr>
            )}
            {!isPrinting &&
                <tr>
                    <td></td>
                    <td colSpan={5}>
                        <InvoiceItemForm invoiceDetails={invoiceDetails} callBack={getItemList} productList={productList} />
                    </td>
                    <td></td>
                    <td></td>
                </tr>
            }
        </tbody>
        <tbody>
            
        </tbody>
        <tfoot>
            <tr>
                <th colSpan={7}><div className='float-end fst-italic'>Total</div></th>
                <th>{subTotal}</th>
                {/*
                    <th>{gstTotal}</th>
                    <th>{grandTotal}</th>
                */}
            </tr>
            <tr className='table-light'>
                 <th colSpan={7}><div className='float-end fst-italic'> SGST</div></th>
                 <th>{gstTotal/2}</th>
            </tr>
            <tr>
                 <th colSpan={7}><div className='float-end fst-italic'>CGST</div></th>
                 <th>{gstTotal/2}</th>
            </tr>
            <tr className='table-active'>
                 <th colSpan={7}><div className='float-end'>Grand Total</div></th>
                 <th>{grandTotal}</th>
            </tr>
            <tr >
                <td colSpan={8}>
                    <div>Amount Chargeable (in words) : <span className='fw-bold ms-2'><NumberToWords amount={grandTotal} /> Only</span></div>
                </td>
            </tr>
        </tfoot>
    </table>
    
  )
}

export default InvoiceItemList